import { Tabs } from '@chakra-ui/react';
import SimpleRoundCommand from '@components/map/popup/round/SimpleRoundCommand';
import { FormattedMessage } from 'react-intl';

import ComplexRoundCommand from './ComplexRoundCommand';

type Props = {
  uniqueKey: string;
};

export default function RoundContent({ uniqueKey }: Readonly<Props>) {
  return (
    <Tabs.Root size="screenStd" variant="neutral" height="max-content" defaultValue="complex">
      <Tabs.List>
        <Tabs.Trigger value="complex">
          <FormattedMessage id="rounds.complex" />
        </Tabs.Trigger>
        <Tabs.Trigger value="simple">
          <FormattedMessage id="rounds.simple" />
        </Tabs.Trigger>
      </Tabs.List>
      <Tabs.ContentGroup>
        <Tabs.Content value="complex">
          <ComplexRoundCommand uniqueKey={uniqueKey} />
        </Tabs.Content>
        <Tabs.Content value="simple">
          <SimpleRoundCommand uniqueKey={uniqueKey} />
        </Tabs.Content>
      </Tabs.ContentGroup>
    </Tabs.Root>
  );
}
